var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 5,
    fill: "#E3F2FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 16.0817V12.0264C25.5 9.08119 23.6659 7 20.7178 7H12.2822C9.34281 7 7.5 9.08119 7.5 12.0264V19.9736C7.5 22.9188 9.33405 25 12.2822 25H14.0325",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 13.4902H7.5",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8445 10.5488H10.7891M13.3321 10.5488H13.2766M15.8177 10.5488H15.7622",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7728 23.2455C21.508 24.5094 19.4589 24.5094 18.194 23.2455C16.9301 21.9816 16.9301 19.9315 18.194 18.6667C19.4589 17.4028 21.508 17.4028 22.7728 18.6667C24.0367 19.9315 24.0367 21.9816 22.7728 23.2455ZM22.7728 23.2455L24.5265 24.9997",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchIcon);
export default __webpack_public_path__ + "static/media/ResearchIcon.542a286ddb145368642306e1d73b8f55.svg";
export { ForwardRef as ReactComponent };